import { Theme } from '@enum/theme'
import React from 'react'
import { TouchableOpacity, Text, View, TouchableOpacityProps } from 'react-native'
import SpaceH from './SpaceH'

interface BlackButtonProps {
  onPressSave?: () => void
  onPressClear?: () => void
  isOK: boolean
  isProximo?: boolean
  isEdit?:boolean
  cancelLabel?: string
  saveLabel?: string
}

const ButtonSalvarLimpar: React.FC<BlackButtonProps & TouchableOpacityProps> = ({ onPressSave, isOK, onPressClear, isProximo, cancelLabel, saveLabel, isEdit }) => {
  return (
    <View style={{padding: 16}}>
      <View style={{
        borderRadius: 10, minWidth: 120
      }}>
        <TouchableOpacity
          disabled={!isOK}
          onPress={() => isOK && onPressClear && onPressClear()}
          style={{
            borderRadius: 8,
            padding: 15,
            justifyContent: 'center'
          }}>
          <Text style={{
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 'bold',
             color: isEdit ? '#E12A45' :  isOK ? cancelLabel ? Theme.primary : '#E12A45' : '#E9E9E9'
          }}>
            {cancelLabel??'Limpar'}
          </Text>
        </TouchableOpacity>
      </View>
      <SpaceH />
      <View style={{
        borderRadius: 10, backgroundColor:   isOK ? isProximo || isEdit ? Theme.primary : '#A0BC44' :  '#D9D9D9', minWidth: 120
      }}>
        <TouchableOpacity
          disabled={!isOK}
          onPress={() => isOK && onPressSave && onPressSave()}
          style={{
            borderRadius: 8,
            padding: 15,
            justifyContent: 'center'
          }}>
          <Text style={{
            textAlign: 'center',
            fontSize: 16,
            fontWeight: 'bold',
            color: isOK ? '#fff' : '#E9E9E9'
          }}>
            {isProximo ? 'Próximo': saveLabel ? saveLabel : 'Salvar'}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}

export default ButtonSalvarLimpar
